import { render, staticRenderFns } from "./ExpenseError.vue?vue&type=template&id=4eb76465&scoped=true&"
import script from "./ExpenseError.vue?vue&type=script&lang=js&"
export * from "./ExpenseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb76465",
  null
  
)

export default component.exports